module.exports = __webpack_public_path__ + "img/bx-class-nickname.b425c032.svg";